/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery, useQueryClient } from "@tanstack/react-query";
import { getInvoiceConfig } from "api/services/invoice";
import { invoiceQueryKeys } from "./invoiceQueryKeys";

type GetInvoiceConfigOptions = {
  shipmentId: string;
  currentInvoiceId?: string;
  options?: UseQueryOptions;
  queryFn?: any;
};

export const useGetInvoiceConfig = (data: GetInvoiceConfigOptions) => {
  const queryClient = useQueryClient();
  let filters: any;

  if (data.currentInvoiceId) {
    const invoices: any = queryClient.getQueryData(invoiceQueryKeys.shipmentInvoicesListing(data.shipmentId));
    const currentInvoice = invoices?.results?.find((invoice: any) => invoice.invoice_id === data.currentInvoiceId);
    if (currentInvoice && currentInvoice.invoice_type === "intermediate_invoice") {
      filters = {
        is_intermediate_invoice: true,
      };
    }
  }

  const queryRes = useQuery({
    queryKey: filters
      ? invoiceQueryKeys.invoiceConfig(data.shipmentId, filters)
      : invoiceQueryKeys.invoiceConfig(data.shipmentId),
    queryFn: data.queryFn
      ? data.queryFn
      : () => getInvoiceConfig(data.shipmentId, { ...(filters && { params: { ...filters } }) }).then((res: any) => res.data),
    ...data.options,
  });

  return queryRes;
};
